import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck, Gift, BookOpen } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  const handleBuyClick = () => {
    trackAddToCart();
    setTimeout(() => {
      window.open('https://legadosalud.com/cart/42376387199061:1', '_blank', 'noopener,noreferrer');
    }, 300);
  };
  return <section id="pricing" className="py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-32">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900 to-navy-800 -z-20" data-id="element-33"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/10 rounded-full blur-[120px] -z-10" data-id="element-34"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-35">
        <FadeIn data-id="element-36">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-37">
            Accede a un sueño reparador hoy mismo.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-38">
          <div className="bg-navy-900/80 backdrop-blur-sm border border-amber-500/30 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto shadow-2xl" data-id="element-39">
            <div className="flex justify-center mb-8" data-id="element-40">
              <img src="https://cdn.magicpatterns.com/uploads/gyV8V8MwVnM4G2dy1xznwF/Portada_SuenoProfundoSP.png" alt="Sueño Profundo Cover" className="w-48 rounded-lg shadow-lg" data-id="element-41" />
            </div>

            <div className="mb-8 text-left bg-navy-800/60 border border-navy-700 rounded-2xl p-6" data-id="element-42">
              <p className="text-center text-amber-500 text-sm uppercase tracking-widest font-bold mb-5" data-id="element-43">
                Esto es lo que llevas hoy
              </p>

              <ul className="space-y-3 mb-2" data-id="element-44">
                <li className="flex items-start gap-3" data-id="element-45">
                  <BookOpen className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-46" />
                  <span className="text-lavender-100" data-id="element-47">
                    <strong className="text-white" data-id="element-48">
                      EBOOK Sueño Profundo Sin Pastillas
                    </strong>
                    <span className="block text-sm text-lavender-300" data-id="element-49">
                      La guía correcta para tu descanso
                    </span>
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-50">
                  <Gift className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-51" />
                  <span className="text-lavender-100" data-id="element-52">
                    <strong className="text-white" data-id="element-53">BONO 1:</strong>{' '}
                    Suplementación Inteligente (+50)
                    <span className="ml-2 text-xs uppercase tracking-wider text-amber-500 font-bold" data-id="element-54">
                      Gratis
                    </span>
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-55">
                  <Gift className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-56" />
                  <span className="text-lavender-100" data-id="element-57">
                    <strong className="text-white" data-id="element-58">BONO 2:</strong> Plan de 7
                    días (reconexión circadiana)
                    <span className="ml-2 text-xs uppercase tracking-wider text-amber-500 font-bold" data-id="element-59">
                      Gratis
                    </span>
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-60">
                  <Gift className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-61" />
                  <span className="text-lavender-100" data-id="element-62">
                    <strong className="text-white" data-id="element-63">BONO 3:</strong> Checklist de
                    higiene térmica
                    <span className="ml-2 text-xs uppercase tracking-wider text-amber-500 font-bold" data-id="element-64">
                      Gratis
                    </span>
                  </span>
                </li>
              </ul>
            </div>

            <div className="mb-8" data-id="element-65">
              <span className="text-lavender-200 text-sm uppercase tracking-wider font-bold" data-id="element-66">
                Valor real:{' '}
                <span className="line-through text-lavender-300" data-id="element-67">$170 USD</span>
              </span>
              <p className="text-amber-500 text-xs uppercase tracking-widest font-bold mt-2 mb-2" data-id="element-68">
                Hoy, por promoción
              </p>
              <div className="flex items-baseline justify-center gap-2 my-2" data-id="element-69">
                <span className="text-5xl md:text-6xl font-bold text-amber-500" data-id="element-70">
                  $17
                </span>
                <span className="text-2xl text-amber-500 font-bold" data-id="element-71">USD</span>
              </div>
              <span className="text-lavender-300 text-sm" data-id="element-72">
                (Pago único · Acceso inmediato)
              </span>
            </div>

            <Button onClick={handleBuyClick} className="w-full py-5 text-xl mb-6" data-id="element-73">
              Descargalo AHORA !!
            </Button>

            <div className="flex flex-col items-center gap-3 text-sm text-lavender-200" data-id="element-74">
              <div className="flex items-center gap-2" data-id="element-75">
                <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-76" />
                <span data-id="element-77">Compra segura.</span>
              </div>
              <p data-id="element-78">Acceso instantáneo en PDF tras el pago.</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}